module.exports = __webpack_public_path__ + "img/default.240ea699.png";